import Box from '@mui/material/Box';
import { Grid } from '@mui/material';
import FormSearhcAndSelectInput from 'common/FormSearchAndSelectInput';
import FormInputLabel from 'common/FormInputLabel';
import { AttachMoney } from '@mui/icons-material';

import FormTextInput from '../../../../../common/FormTextInput';

export default function ServiceInputs({ index, formData, setFormData, setServicesCount, servicesList, disabled, servicesCount, serviceNumber, purchasedService = false, required = true, onAddNewServiceClick }) {
    const handelServiceChange = (e, index) => {
        const { name, value } = e.target;

        if (name === 'servicePrice') {
            // Remove all non-numeric characters
            const numericValue = value.replace(/[^0-9]/g, '');
            
            // Format as currency: convert to cents, then format back
            let finalValue = '';
            if (numericValue) {
                // Convert to number and divide by 100 to get dollars
                const cents = parseInt(numericValue, 10);
                const dollars = cents / 100;
                finalValue = dollars.toFixed(2);
            }
            
            const newPrice = formData.servicePrice;
            newPrice[index] = finalValue;
            setFormData({ ...formData, servicePrice: newPrice });
        }
    };

    const handlePriceFocus = (e, index) => {
        // If the value is empty, set it to "0.00" and select it for easy editing
        const currentValue = formData.servicePrice[index];
        if (!currentValue || currentValue === '') {
            const newPrice = formData.servicePrice;
            newPrice[index] = '0.00';
            setFormData({ ...formData, servicePrice: newPrice });
            setTimeout(() => {
                e.target.select();
            }, 0);
        } else if (currentValue === '0.00') {
            setTimeout(() => {
                e.target.select();
            }, 0);
        }
    };
    const handleRemoveService = (index) => {
        setFormData((prevData) => {
            const newServiceNames = [...prevData.serviceName];
            const newServicePrices = [...prevData.servicePrice];

            newServiceNames.splice(index, 1);
            newServicePrices.splice(index, 1);

            return {
                ...prevData,
                serviceName: newServiceNames,
                servicePrice: newServicePrices,
            };
        });
        setServicesCount((prev) => prev - 1);
    };

    const handleServiceNameChange = (e, value) => {
        // "+ Add new service" opens ServicePopup when callback is provided (Invoice/Manual Invoice)
        if (value === '+ Add new service' && onAddNewServiceClick) {
            onAddNewServiceClick(index);
            return;
        }

        const previousValue = formData.serviceName[index];
        const newService = formData.serviceName;
        const newServicePrice = formData.servicePrice;
        newService[index] = value;

        if (value && value !== previousValue && servicesList && servicesList.length > 0 && !disabled) {
            const selectedService = servicesList.find(service => service.name === value);
            if (selectedService && selectedService.price !== null && selectedService.price !== undefined) {
                newServicePrice[index] = Number(selectedService.price || 0).toFixed(2);
            }
        }
        setFormData({ ...formData, serviceName: newService, servicePrice: newServicePrice });
    };

    const showContainer = servicesCount > 1;
    return (
        <Box
            style={{
                border: showContainer ? '1px solid #E1E1E1' : 'none',
                borderRadius: showContainer ? '8px' : '0px',
                padding: showContainer ? '16px' : '0px',
                paddingLeft: showContainer ? '16px' : '0px',
                paddingRight: showContainer ? '16px' : '0px',
                marginBottom: '8px',
                marginTop: (showContainer && index === servicesCount - 1) ? '12px' : '0px',
                width: '100%',
                boxSizing: 'border-box'
            }}
        >
            <Grid container spacing={0} sx={{ marginTop: '0px' }}>
                <FormSearhcAndSelectInput
                    required={required}
                    name="serviceName"
                    label={servicesCount > 1 ? `Service ${serviceNumber} Name` : 'Service Name'}
                    options={
                        [
                            '+ Add new service',
                            ...(servicesList && servicesList.length > 0 ? servicesList.map(service => service.name) : []),
                        ]
                    }
                    value={formData.serviceName[index] ?? ''}
                    onChange={handleServiceNameChange}
                    disabled={disabled}
                    placeholder="Select or search service..."
                    renderOption={(props, option) => (
                        <li {...props}>
                            {option === '+ Add new service' ? (
                                <span style={{ fontStyle: 'italic' }}>{option}</span>
                            ) : (
                                option
                            )}
                        </li>
                    )}
                    labelSize={6}
                    inputSize={6}
                    style={{ marginBottom: '8px' }}
                />

                <FormTextInput
                    formData={formData}
                    label={servicesCount > 1 ? `Service ${serviceNumber} Price` : 'Service Price'}
                    value={formData.servicePrice[index] ?? ""}
                    name="servicePrice"
                    handleChange={(e) => handelServiceChange(e, index)}
                    placeholder="0.00"
                    subText=""
                    required={required}
                    index={index}
                    disabled={disabled}
                    type="number"
                    labelSize={6}
                    textSize={6}
                    style={{ marginBottom: '8px' }}
                inputProps={{
                        step: "0.01",
                        min: "0",
                        inputMode: "decimal",
                        style: { textAlign: 'right' },
                        onFocus: (e) => handlePriceFocus(e, index),
                        onKeyDown: (ev) => {
                            const allowed = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'];
                            if (allowed.includes(ev.key)) return;
                            const isDigit = /[0-9]/.test(ev.key);
                            if (!isDigit) {
                                ev.preventDefault();
                                return;
                            }
                        },
                        onPaste: (ev) => {
                            const paste = (ev.clipboardData || window.clipboardData).getData('text');
                            if (!/^\d*$/.test(paste)) {
                                ev.preventDefault();
                            }
                        }
                    }}
                    InputProps={{
                        startAdornment: (
                            <Box
                                sx={{
                                    backgroundColor: 'rgba(203, 193, 183, 1)',
                                    color: 'rgba(87, 83, 78, 1)',
                                    height: '42px',
                                    width: '42px !important',
                                    minWidth: '42px !important',
                                    maxWidth: '42px !important',
                                    flexBasis: '42px !important',
                                    flexGrow: '0 !important',
                                    flexShrink: '0 !important',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: '-14px',
                                    borderTopLeftRadius: '7px',
                                    borderBottomLeftRadius: '7px',
                                }}
                            >
                                <AttachMoney fontSize="small" />
                            </Box>
                        ),
                        sx: {
                            '& input[type=number]': {
                                MozAppearance: 'textfield',
                                textAlign: 'right',
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& input[type=number]:hover': {
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& input[type=number]:focus': {
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& input[type=number]:focus-visible': {
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& input[type=number]:focus-within': {
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& fieldset': {
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& fieldset:hover': {
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& fieldset:focus': {
                                borderTopLeftRadius: '0px',
                                borderBottomLeftRadius: '0px',
                            },
                            '& .MuiInputAdornment-root': {
                                maxWidth: 'none !important',
                                minWidth: '42px !important',
                                width: '42px !important',
                                flexBasis: '42px !important',
                                flexGrow: '0 !important',
                                flexShrink: '0 !important',
                            },
                            '& input[type=number]::-webkit-outer-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                            },
                            '& input[type=number]::-webkit-inner-spin-button': {
                                WebkitAppearance: 'none',
                                margin: 0,
                            },
                        }
                    }}
                    additionAction={
                        servicesCount > 1 && !disabled && (
                            <Box
                                className={'danger-link'}
                                sx={{ cursor: 'pointer', textAlign: 'right', marginTop: '12px', marginBottom: '0px' }}
                                onClick={() => handleRemoveService(index)}
                            >
                                - Remove Service
                            </Box>
                        )
                    }
                    style={{ marginBottom: '0px' }}
                />
            </Grid>
        </Box>
    );
}
